import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import {
  useAcceptInvitationMutation,
  useCheckInvitationStatusMutation,
} from "../../store";
import Alerts from "../../Components/Utils/Alert";

const SUCCESS_REDIRECT_MS = 2500;

export default function InvitationPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";

  const [acceptInvitation, result] = useAcceptInvitationMutation();
  // AÇILIŞTA BAĞLANTI KONTROLÜ (#223): süresi dolmuş / kullanılmış bağlantıda
  // şifre formu hiç gösterilmez. Kontrol isteği başarısız olursa (ağ, hız
  // sınırı) form gösterilir — sunucu kabulde zaten yeniden doğrular.
  const [checkStatus, statusResult] = useCheckInvitationStatusMutation();
  useEffect(() => {
    if (token.trim()) checkStatus({ token });
  }, [token, checkStatus]);
  const linkStatus = statusResult.data?.data?.status;
  const [newPassword, setNewPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [alert, setAlert] = useState(0);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (result.isSuccess) {
      setAlert(1);
      setMessage(
        result.data?.message || "Şifreniz belirlendi. Giriş yapabilirsiniz."
      );
      const t = setTimeout(
        () => navigate("/", { replace: true }),
        SUCCESS_REDIRECT_MS
      );
      return () => clearTimeout(t);
    }
    if (result.isError) {
      setAlert(2);
      setMessage(
        result.error?.data?.message ||
          "Davet linki geçersiz veya süresi dolmuş. Lütfen yeni bir davet talep edin."
      );
    }
  }, [
    result.isSuccess,
    result.isError,
    result.data?.message,
    result.error?.data?.message,
    navigate,
  ]);

  useEffect(() => {
    if (alert !== 0) {
      const t = setTimeout(() => {
        setAlert(0);
        setMessage("");
      }, 4000);
      return () => clearTimeout(t);
    }
  }, [alert]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!token.trim()) {
      setAlert(2);
      setMessage("Davet linki eksik. E-postanızdaki linki kullanın.");
      return;
    }
    if (newPassword.length < 8) {
      setAlert(2);
      setMessage("Şifre en az 8 karakter olmalıdır.");
      return;
    }
    if (newPassword !== passwordConfirm) {
      setAlert(2);
      setMessage("Şifreler eşleşmiyor.");
      return;
    }
    acceptInvitation({ token, newPassword, passwordConfirm });
  };

  if (!token.trim()) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
        <div className="w-full max-w-md rounded-xl border-2 border-slate-200 bg-white shadow-xl p-8 text-center space-y-4">
          <h1 className="text-lg font-semibold text-slate-800">
            Davet linki eksik
          </h1>
          <p className="text-slate-600 text-sm">
            Hesabınız için gönderilen e-postadaki davet linkini kullanın. Link 7
            gün geçerlidir.
          </p>
          <Link
            to="/"
            className="inline-block w-full py-3 px-4 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700"
          >
            Giriş sayfasına dön
          </Link>
        </div>
      </div>
    );
  }

  if (statusResult.isLoading || statusResult.isUninitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
        <div className="flex items-center gap-3 text-slate-600 text-sm">
          <div className="w-5 h-5 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
          Davet bağlantısı kontrol ediliyor...
        </div>
      </div>
    );
  }

  if (linkStatus === "expired" || linkStatus === "invalid") {
    const expired = linkStatus === "expired";
    return (
      <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
        <div className="w-full max-w-md rounded-xl border-2 border-slate-200 bg-white shadow-xl p-8 text-center space-y-4">
          <h1 className="text-lg font-semibold text-slate-800">
            {expired
              ? "Davet bağlantısının süresi dolmuş"
              : "Bu davet bağlantısı geçersiz"}
          </h1>
          <p className="text-slate-600 text-sm">
            {expired
              ? "Davet bağlantıları 7 gün geçerlidir. Hesabınızı açan yöneticiden yeni davet e-postası göndermesini isteyin."
              : "Bağlantı daha önce kullanılmış ya da hatalı. Şifrenizi zaten belirlediyseniz giriş yapabilirsiniz; belirlemediyseniz yöneticinizden yeni davet isteyin."}
          </p>
          <Link
            to="/"
            className="inline-block w-full py-3 px-4 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700"
          >
            Giriş sayfasına dön
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
      {alert !== 0 && (
        <div className="fixed inset-0 z-[9999] pointer-events-none flex justify-center pt-6 px-4">
          <div className="pointer-events-auto">
            <Alerts AlertChoice={alert} message={message} />
          </div>
        </div>
      )}
      <div className="w-full max-w-md rounded-xl border-2 border-slate-200 bg-white shadow-xl p-6 sm:p-8">
        <h1 className="text-xl font-semibold text-slate-800 mb-2">
          Hesabınız hazır – Şifrenizi belirleyin
        </h1>
        <p className="text-slate-600 text-sm mb-6">
          Hesabınız oluşturuldu. Aşağıya ilk giriş şifrenizi girin (en az 8
          karakter).
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-slate-600 text-sm font-medium mb-1">
              Yeni şifre
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              minLength={8}
              required
              className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
              placeholder="En az 8 karakter"
              disabled={result.isLoading}
            />
          </div>
          <div>
            <label className="block text-slate-600 text-sm font-medium mb-1">
              Yeni şifre (tekrar)
            </label>
            <input
              type="password"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              minLength={8}
              required
              className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
              placeholder="Şifreyi tekrar girin"
              disabled={result.isLoading}
            />
          </div>
          <div className="flex gap-2 pt-2">
            <Link
              to="/"
              className="flex-1 py-3 px-4 rounded-lg border border-slate-300 text-slate-700 text-center font-medium hover:bg-slate-50"
            >
              İptal
            </Link>
            <button
              type="submit"
              disabled={
                result.isLoading ||
                newPassword.length < 8 ||
                newPassword !== passwordConfirm
              }
              className="flex-1 py-3 px-4 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {result.isLoading ? "Kaydediliyor..." : "Şifreyi belirle"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
